import { DeviceType } from '@Types/onboarding.types';
import { formatISO, parse, isValid } from 'date-fns';

export const checkIsFromLiliApp = (): boolean => {
  const origins = ['Lili', 'liliapp'] as const;
  let status = false;
  origins.map((origin) => {
    if (navigator.userAgent.toLowerCase().includes(origin.toLowerCase())) {
      status = true;
      return;
    }
  });
  return status;
};

export const checkDeviceType = () => {
  let type = DeviceType.UNKNOWN;
  if (!!navigator.userAgent && /iPad|iPhone|iPod|MacIntel/.test(navigator.userAgent)) {
    type = DeviceType.IOS;
  } else if (!!navigator.userAgent && /android|Android/i.test(navigator.userAgent)) {
    type = DeviceType.ANDROID;
  }
  return type;
};

export const getQueryParamsObject = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const entries = params.entries();
  return Object.fromEntries(entries);
};

export const isObjectEmpty = (obj: Record<string, unknown>): boolean => {
  return Object.keys(obj).length === 0;
};

export const getCookiesList = () => {
  return document.cookie.split(';').map((c) => c.trim());
};
export const triggerBlurForAllFields = () => {
  const formElements = document.querySelectorAll('input, select, textarea');
  formElements.forEach((element) => {
    element.dispatchEvent(new Event('blur'));
  });
};

export const getParsedDateAsISO = (dateStr: string) => {
  const parsedDate = parse(dateStr, 'MM/dd/yyyy', new Date());
  return formatISO(parsedDate);
};

export const getIsDateValid = (dateStr: string) => {
  let isDateValid = false;
  try {
    const parsedDate = parse(dateStr, 'MM/dd/yyyy', new Date());
    isDateValid = isValid(parsedDate);
  } catch {
    isDateValid = false;
  }
  return isDateValid;
};

export const toKebabCase = (str: string) => {
  return (
    str
      // Insert a hyphen before each uppercase letter and convert the letter to lowercase
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      // Convert underscores, spaces, and multiple hyphens to a single hyphen
      .replace(/[_\s]+/g, '-')
      // Convert the entire string to lowercase
      .toLowerCase()
  );
};

export const normalizeInputSpacesOnChange = (str: string) => {
  return str.replace(/\s+/g, ' ').trimStart();
};

export const normalizeInputSpacesOnBlur = (str: string) => {
  return str.trimEnd();
};

export const normalizeSsnInput = (str: string) => {
  return str.replace(/-/g, '');
};

export const normalizeBirthDateInput = (str: string) => {
  if (str.includes('+')) {
    return str.split('+')[0];
  }
  return str;
};

export const maskPhoneNumber = (phoneNumber: string): string => {
  const phoneRegex = /^\+\d+\s\((\d{3})\)\s(\d{2})\d+-(\d{4})$/;
  const match = phoneNumber.match(phoneRegex);

  if (!match) {
    throw new Error('Invalid phone number format');
  }

  const areaCode = match[1];
  const maskedSection = '••-•••';
  const lastFour = match[3];

  return `(${areaCode}) ${maskedSection}-${lastFour}`;
};

export const getUserFirstName = (fullName: string) => {
  return fullName.split(' ').at(0) || '';
};

export const convertToTimeFormat = (num: number) => {
  const hours = Math.floor(num / 60);
  const minutes = num % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};
